import { type FC } from "react";

import { Button } from "@mantine/core";

import snapLogoOutlineGradientSvg from "@app-assets/svg/snapchat-logo-outline-gradient.svg";

import { ApplyText } from "../../submit/components/shared/messages.generated";

import styles from "./ExclusiveLensToggle.module.css";

interface ExclusiveLensApplyButtonProps {
    applyUrl: string;
}

export const ExclusiveLensApplyButton: FC<ExclusiveLensApplyButtonProps> = ({ applyUrl }) => {
    return (
        <>
            <div className={styles.showApplyBg}>
                <figure className={styles.snapLogo}>
                    <img src={snapLogoOutlineGradientSvg} alt="Snapchat Logo Outline Gradient" />
                </figure>
            </div>
            <a href={applyUrl} target="_blank" rel="noreferrer">
                <Button className={styles.applyButton}>
                    <ApplyText />
                </Button>
            </a>
        </>
    );
};
